module.exports = __webpack_public_path__ + "static/work.298f83fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/newLayout/assets/distributor/work.png
// module id = 810
// module chunks = 13643350389075